import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const context = require.context('./modules', true, /.js/);
const modules = {};
context.keys().forEach((file) => {
    const moduleName = file.replace(/.\/(.+).js/, '$1');
    modules[moduleName] = context(file).default || context(file);
    modules[moduleName].namespaced = true;
});

const store = new Vuex.Store({
    modules,
});

export default store;
